import React from 'react';
import { Button, Form, Input, Switch } from 'antd';

import PartnerLogoUpload from './PartnerLogoUpload';
import type { PartnerProgramServiceFormValue } from '../types/partnerProgramService';

const wideFormItemProps = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 },
  labelAlign: 'left' as const,
};

const fieldGroupStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '100%',
};

const inlineRowStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
};

const stackedRowStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  width: '100%',
};

const addButtonStyle = { color: '#637f92', fontWeight: 600 };

const visibleStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  color: '#333',
  whiteSpace: 'nowrap',
};

const thumbnailStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 8,
  color: '#333',
};

function createEmptyService(): PartnerProgramServiceFormValue {
  return {
    id: `custom-${Date.now()}`,
    title: '',
    image: '',
    href: '',
    isActive: true,
  };
}

const PartnerProgramServicesEditor: React.FC = () => {
  return (
    <Form.List name="partnerProgramServices">
      {(fields, { add, remove }) => (
        <>
          {fields.map((field, index) => (
            <Form.Item
              key={field.key}
              label={`Service ${index + 1}`}
              {...wideFormItemProps}
              required
            >
              <Form.Item name={[field.name, 'id']} style={{ display: 'none' }} hidden>
                <Input />
              </Form.Item>
              <Form.Item name={[field.name, 'iconKey']} style={{ display: 'none' }} hidden>
                <Input />
              </Form.Item>

              <div style={{ ...fieldGroupStyle, width: '100%' }}>
                <div style={inlineRowStyle}>
                  <Form.Item
                    {...field}
                    name={[field.name, 'title']}
                    rules={[{ required: true, message: 'Service name is required' }]}
                    style={{ flex: 1, marginBottom: 0 }}
                  >
                    <Input placeholder="Service name" />
                  </Form.Item>
                  <div style={{ ...visibleStyle, marginLeft: '20px' }}>
                    <span>Visible:</span>
                    <Form.Item
                      {...field}
                      name={[field.name, 'isActive']}
                      valuePropName="checked"
                      style={{ marginBottom: 0 }}
                    >
                      <Switch />
                    </Form.Item>
                  </div>
                  <Button danger onClick={() => remove(field.name)}>
                    Remove
                  </Button>
                </div>

                <div style={stackedRowStyle}>
                  <span>Link URL:</span>
                  <Form.Item {...field} name={[field.name, 'href']} style={{ marginBottom: 0 }}>
                    <Input placeholder="Link URL, e.g. /visa or https://documitra.com/visa" />
                  </Form.Item>
                </div>

                <div style={thumbnailStyle}>
                  <span>Thumbnail image:</span>
                  <Form.Item
                    {...field}
                    name={[field.name, 'image']}
                    rules={[{ required: true, message: 'Image is required' }]}
                    style={{ marginBottom: 0 }}
                  >
                    <PartnerLogoUpload />
                  </Form.Item>
                </div>
              </div>
            </Form.Item>
          ))}

          <Form.Item wrapperCol={{ span: 12, offset: 4 }}>
            <Button type="dashed" onClick={() => add(createEmptyService())} style={addButtonStyle}>
              {fields.length === 0 ? '+ Add First Service' : '+ Add Service'}
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>
  );
};

export default PartnerProgramServicesEditor;
